module.exports = __webpack_public_path__ + "img/0S6A9771.fbf3be39.jpg";